import { GridSize, IFormBase } from '../typings';
import { DefaultFormFieldBuilder } from '.';

export abstract class BaseFormFieldBuilder<
  T,
> extends DefaultFormFieldBuilder<T> {
  protected _label: IFormBase['label'] = 'Label not provided';
  protected _readonly: IFormBase['readonly'] = false;
  protected _placeholder?: IFormBase['placeholder'];
  protected _value?: IFormBase['value'];
  protected _size?: IFormBase['size'];

  protected constructor() {
    super();
  }

  public label(value: IFormBase['label']): this {
    this._label = value;
    return this;
  }

  public readonly(value: IFormBase['readonly']): this {
    this._readonly = value;
    return this;
  }

  public value(value: IFormBase['value']): this {
    this._value = value;
    return this;
  }

  public placeholder(value: IFormBase['placeholder']): this {
    this._placeholder = value;
    return this;
  }

  public size(value: GridSize): this {
    this._size = { md: value };
    return this;
  }
}
